<div class="equipment-card" [routerLink]="['/details',equipment()?.id]" routerLinkActive="router-link-active" >
  <div class="equipment-card__wrapper">
    <img class="equipment-card__image" [src]="equipment().equipmentMedia | mainImage" alt="equipment">
    <div class="equipment-card__info">
        <div  class="equipment-card__title">{{equipment()?.title}}</div>
        <div  class="equipment-card__invNumber">{{equipment()?.invNumber}}</div>
        <div  class="equipment-card__category">{{equipment()?.category?.name}}</div>
    </div>
  </div>
</div>